export const TestIdAttrName = 'data-testid'
